import 'intl';
import '@formatjs/intl-pluralrules/polyfill';
import '@formatjs/intl-pluralrules/locale-data/ru';
import '@formatjs/intl-numberformat/polyfill';
import '@formatjs/intl-numberformat/locale-data/ru';

const formatNumber = (value, locale, options) => {
  return !options
    ? new Intl.NumberFormat(locale).format(value)
    : new Intl.NumberFormat(locale, options).format(value);
};

export default formatNumber;
